<template>
  <div
    v-if="currentUser != null"
    class="l-contentmain contentmain">
    <page-nav-bar
      v-if="u"
      :is-sticky="true"
      :back-button="true"
      :has-actions="!isMe && !user.first_admin">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <router-link :to="{ name: 'UserList'}">
            Utilisateurs
          </router-link>
        </h1>
        <div class="page-header-breadcrumb-separator"></div>
        <div
          class="page-header-breadcrumb-item"
          v-if="u && u.last_name && u.first_name && !isMe">
          <span class="has-text-weight-normal has-text-grey-dark"><span class="is-uppercase">{{ u.last_name }}</span> {{ u.first_name }}</span>
        </div>
        <div
          v-else
          class="page-header-breadcrumb-item">
          <span class="has-text-weight-normal has-text-grey-dark">Mon compte</span>
        </div>
      </template>
      <router-link
        :to="{name: 'UserEdit', params: {id: u.pk}}"
        class="dropdown-item"
        slot="dropdown-content"
        v-if="isAdmin"
        id="userEditButton">
        <span class="icon is-medium"><i class="fas fa-user-edit"></i></span>
        <span class="is-margin-left-small">Modifier fiche</span>
      </router-link>
      <router-link
        :to="{name: 'UserEdit', params: {id: u.pk}}"
        class="dropdown-item"
        slot="dropdown-content"
        v-if="isManager && u.manager && u.manager.pk == currentUser.pk"
        id="userEditButton">
        <span class="icon is-medium"><i class="fas fa-user-edit"></i></span>
        <span class="is-margin-left-small">Modifier fiche</span>
      </router-link>
      <a
        slot="dropdown-content"
        v-if="(isAdmin || isManager) && u.pk !== currentUser.pk"
        @click="inviteUser(u)"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-paper-plane"></i></span><span class="is-margin-left-small">Envoyer invitation</span>
      </a>
      Desactiver User
      <a
        slot="dropdown-content"
        class="dropdown-item  has-background-primary has-text-white"
        id="userDesactiveButton"
        @click="updateStatusUser(u)"
        v-if="isAdmin && u.pk !== currentUser.pk && !user.locked && !user.first_admin">
        <span class="icon is-medium"><i class="fas fa-user-slash"></i></span><span class="is-margin-left-small">Désactiver le compte</span>
      </a>
      Réactiver User
      <a
        slot="dropdown-content"
        class="dropdown-item has-background-reserved has-text-white"
        id="userReactivButton"
        @click="updateStatusUser(u)"
        v-if="isAdmin && u.pk !== currentUser.pk && user.locked && !user.first_admin">
        <span class="icon is-medium"><i class="fas fa-eye"></i></span><span class="is-margin-left-small">Réactiver le compte</span>
      </a>
      <a
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        id="userDeleteButton"
        @click="deleteUser(u.pk)"
        v-if="isAdmin && u.pk !== currentUser.pk">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span><span class="is-margin-left-small">Supprimer</span>
      </a>
      <a
        slot="dropdown-content"
        class="dropdown-item has-background-danger has-text-white"
        id="userDeleteButton"
        @click="deleteUser(u.pk)"
        v-if="isManager && u.manager && u.manager.pk == currentUser.pk">
        <span class="icon is-medium"><i class="fas fa-trash-alt"></i></span><span class="is-margin-left-small">Supprimer</span>
      </a>
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-content
      v-else-if="u && !loading"
      :has-left-col-small="true"
      :has-left-col-small-size-fixed="false"
      :has-sticky-col-left="true">
      <template slot="left-col-small">
        <user-left-col
          :source-user="u"
          :agence="agence"
          :source-me="isMe"
          @updateManager="setManager"
          @updateUser="updateUser"
          @uploadUserAvatar="uploadUserAvatar"></user-left-col>
        <event-tracker-list :field="'user'"></event-tracker-list>
      </template>
      <div class="has-background-white is-border">
        <tabs
          :links="userTabLinks"
          class="is-border-bottom"></tabs>
        <router-view
          :key="$route.name"
          :source-user="u"
          :source-user-rdvs="userRdvs"
          :source-user-options="userOptions"
          :source-user-contacts="userContacts"
          :source-user-reservations="userReservations"
          :source-user-groups="userGroups"
          :source-user-team="userTeam"
          @getUserContacts="getUserContacts"
          @updateTeam="updateTeam"
          @reloadUser="getUser"></router-view>
      </div>
    </page-content>
  </div>
</template>

<script>
import { User, DefaultValues, Quickview } from '@/mixins'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'UserVue',
  components: {
    UserLeftCol: () => import('./UserLeftCol')
  },
  mixins: [User, DefaultValues, Quickview],
  computed: {
    ...mapGetters(['statsEnabled']),
    ...mapState(['quickview'])
  },
  watch: {
    userView (v) {
      if (v === 'UserVue') {
        this.$router.replace({ name: 'UserStats' })
      }
    }
  },
  created () {
    if (!(this.userView in this.userTabLinks.map(x => x.link))) {
      if (this.statsEnabled) {
        this.$router.replace({ name: 'UserStats' })
      } else {
        this.$router.replace({ name: 'UserOptions' })
      }
    }
  },
  methods: {
    async updateStatusUser (user) {
      if (user.locked === false) {
        this.$swal({
          title: 'Désactiver le compte',
          text: 'Ce compte utilisateur sera désactivé, son accès à Vadimm sera restreint jusqu\'à sa réactivation. Les options, ventes et contacts liés à ce compte ne seront pas impactés.',
          confirmButtonText: 'Désactiver',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-danger'
          }
        }).then(async value => {
          if (value && value.dismiss) {
          } else if (value) {
            try {
              user.locked = !user.locked
              await this.$api.patch(this.$resources.USER, user.pk, user)
              this.$toasted.global.success('Compte user désactiver')
            } catch (e) {
              this.$toasted.global.danger('Erreur lors de la désactivation !')
            }
          }
        })
      } else if (user.locked === true) {
        this.$swal({
          title: 'Réactiver le compte',
          text: 'Ce compte sera réactivé. L\'utilisateur pourra à nouveau se connecter à Vadimm. Êtes-vous sûr de vouloir réactiver ce compte ?',
          confirmButtonText: 'Réactiver',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-success'
          }
        }).then(async value => {
          if (value && value.dismiss) {
          } else if (value) {
            try {
              user.locked = !user.locked
              await this.$api.patch(this.$resources.USER, user.pk, user)
              this.$toasted.global.success('Compte user désactiver')
            } catch (e) {
              this.$toasted.global.danger('Erreur lors de la désactivation !')
            }
          }
        })
      }
    }
  }
}
</script>
